import React from 'react';
import Image from 'next/image';

const IconList = ({ list }) => (
  <ul className="space-y-4 lg:space-y-8">
    {list.map(({ img, title }) => (
      <li
        className="flex flex-row justify-start overflow-hidden text-gray-400 text-md lg:text-lg whitespace-nowrap"
        key={title}
      >
        <span className="flex items-center mr-3">
          <Image
            src={img?.src}
            width="24"
            height="24"
            alt={img?.alt}
            layout="fixed"
            loading="eager"
            priority
          />
        </span>
        {title}
      </li>
    ))}
  </ul>
);
const AnnotationTypes = ({ dataInputsFeatures, sensorFusion }) => (
  <>
    <div className="flex flex-col items-start justify-between xl:pr-4 gap-y-10 md:flex-row md:flex-wrap md:gap-10">
      <div className="flex flex-col justify-between gap-y-9">
        <div className="space-y-5">
          <p className="text-2xl sm:text-2xl text-scale-lightskyblue">Scale Text</p>
          <IconList list={dataInputsFeatures.scaleText} />
        </div>
        <div className="space-y-5">
          <p className="text-2xl sm:text-2xl text-scale-skyblue">Scale Audio</p>
          <IconList list={dataInputsFeatures.scaleAudio} />
        </div>
        {sensorFusion && (
          <div className="space-y-5">
            <p className="text-2xl sm:text-2xl text-scale-periwinkle whitespace-nowrap">
              Scale 3D Sensor Fusion
            </p>
            <IconList list={dataInputsFeatures.scale3dSensorFusion} />
          </div>
        )}
      </div>
      <div className="space-y-5">
        <p className="text-2xl sm:text-2xl text-scale-mauve">Scale Video</p>
        <IconList list={dataInputsFeatures.scaleVideo} />
      </div>
      <div className="space-y-5">
        <p className="text-2xl sm:text-2xl text-scale-lightmauve">Scale Image</p>
        <IconList list={dataInputsFeatures.scaleImage} />
      </div>
    </div>
  </>
);

export default AnnotationTypes;
